import React, { useState, useContext } from 'react';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { makeStyles } from '@material-ui/core/styles';
import { Button, AppBar, Toolbar, IconButton, Typography, Backdrop, CircularProgress, Fab, Grid } from '@material-ui/core';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';
import styles from "../../../jss/material-dashboard-react/views/dashboardStyle.js";
import { HttpService } from "../../../apiAuthorization/httpService";
import { GlobalTheme } from '../../../layouts/theme';
import { Theme } from '../../contexts/themeContext.js';
import Card from "../../card/card.js";
import CardBody from "../../card/cardBody.js";
import GridItem from "../../grid/gridItem.js";
import GridContainer from "../../grid/gridContainer.js";
import AlertDialog from '../../common/alertDialog';
import SmallMenu from '../../header/smallMenu';
import StatusIcon from '../../common/statusIcon';

const useStyles = makeStyles(styles);

export default function AddUserGroup(props) {
    const classes = useStyles();
    const id = props.model.length === 0 ? 0 : props.model.AppModuleGroupId;
    const action = props.model.length === 0 ? "Add" : "Edit";
    const { theme } = useContext(Theme);
    const [alertOpen, setAlertOpen] = React.useState(false);
    const [severity, setSeverity] = React.useState('');
    const [errorMessage, setErrorMessage] = React.useState('');
    const [groupName, setGroupName] = useState(props.model.length === 0 ? '' : props.model.AppModuleGroupName);
    const [backDrop, setBackDrop] = useState(false);
    const [modified, setModified] = useState(false);
    const currentTheme = theme ? (GlobalTheme[theme]) : (GlobalTheme[localStorage.getItem("theme")]);

    const alertClose = () => {
        setAlertOpen(false);
    };

    const saveUserGroup = (goBack) => {
        if (backDrop) {
            return;
        }
        else if (modified && groupName !== "") {
            setBackDrop(true);
            HttpService.post('/UserGroup/SaveAppModuleGroup', {
                AppModuleGroupId: id,
                AppModuleGroupName: groupName
            })
                .then((result) => {
                    if (result.error) {
                        setBackDrop(false);
                        setErrorMessage(result.message);
                        setSeverity('error');
                        setAlertOpen(true);
                    }
                    else {
                        props.refreshGrid(result.data);
                        props.parentCallback();
                    }
                },
                    (error) => {
                        console.log(error);
                    });
        }
        else if (goBack) {
            props.parentCallback();
        }
    };

    return (<>
        <GridContainer style={{ justifyContent: 'center' }}>
            <Backdrop className={classes.backdrop} id="userGroupAddBackdrop" open={backDrop}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={() => saveUserGroup(true)} aria-label="back">
                        <KeyboardBackspaceIcon />
                    </IconButton>
                    <Grid container direction="row" alignItems="center">
                        <Grid item>
                            <Typography variant="h6" className={classes.title}>{action} User Group</Typography>
                        </Grid>
                        <Grid item>
                            <StatusIcon />
                        </Grid>
                    </Grid>
                    <Grid container justify="flex-end">
                        <Fab style={{ background: currentTheme.secondary, color: "white" }} size="small" aria-label="close" onClick={props.parentCallback}>
                            <CloseIcon />
                        </Fab>
                        <SmallMenu modified={modified} saveCallback={() => saveUserGroup(false)} />
                    </Grid>
                </Toolbar>
            </AppBar>
            <GridItem xs={6} sm={6} md={6} >
                <Card style={{ backgroundColor: currentTheme.background }}>
                    <CardBody style={{ color: currentTheme.text, marginTop: "50px", display: 'flex', justifyContent: 'center' }}>
                        <ValidatorForm className={classes.root} autoComplete="off" onSubmit={() => saveUserGroup(false)} style={{ width: "100%", display: "block" }}>
                            <TextValidator
                                label="Group Name"
                                placeholder="Group Name"
                                name="groupName"
                                validators={['required']}
                                errorMessages={['This field is required']}
                                variant="outlined"
                                required
                                value={groupName}
                                onChange={(e) => {
                                    setGroupName(e.target.value);
                                    setModified(true);
                                }}
                                InputLabelProps={{
                                    shrink: true
                                }}
                                style={{ width: "100%" }}
                            />
                            <br /><br />
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                className={classes.button}
                                style={{ background: currentTheme.secondary, width: "100px", float: "right" }}
                                startIcon={<SaveIcon />}
                                type="submit"
                            >
                                Save
                            </Button>
                        </ValidatorForm>
                    </CardBody>
                </Card>
            </GridItem>
        </GridContainer>
        <AlertDialog open={alertOpen} close={alertClose} message={errorMessage} severity={severity} />
    </>
    );
}
